<template>
    <div class="payment">
        <div
            v-if="
                hotelRooms !== undefined &&
                hotelRooms !== null &&
                !hotelRooms.length &&
                registerType === 'hotels'
            "
        >
            Brak dostępnych hoteli
        </div>
        <div v-if="!content">
            <div class="row">
                <div class="user-type-section col-md-4 col-sm-12">
                    <div class="form-check mb-1">
                        <input
                            type="radio"
                            class="form-check-input"
                            v-model="type"
                            value="online"
                            id="userOnline"
                            @change="attendanceType(false)"
                        />
                        <label class="form-check-label" for="userOnline">
                            Udział online
                        </label>
                    </div>
                    <div class="form-check mb-0">
                        <input
                            type="radio"
                            class="form-check-input"
                            v-model="type"
                            value="offline"
                            id="userOffline"
                            @change="attendanceType(true)"
                        />
                        <label
                            class="form-check-label"
                            for="userOffline"
                            id="userOfflineLabel"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                        >
                            Udział stacjonarny
                        </label>
                    </div>
                </div>
                <div
                    v-if="registerType === 'hotels' && this.type === 'offline'"
                    class="col-md-4 col-sm-12"
                >
                    <div class="col-sm-12">
                        <div class="form-row">
                            <label>Hotel</label>
                            <select
                                @change="setHotelRoom"
                                class="custom-select"
                                v-model="hotelRoom"
                            >
                                <option disabled selected value="">
                                    Wybierz rekord
                                </option>
                                <option
                                    v-for="hotelRoom in hotelRooms"
                                    :value="hotelRoom"
                                >
                                    {{ hotelRoom.hotel_name }} -
                                    {{ hotelRoom.name }}
                                </option>
                            </select>
                        </div>
                        <div v-if="hotelRoom">
                            <div
                                v-for="(companion, index) in companions"
                                class="form-row mt-1"
                            >
                                <input
                                    @change="checkCompanion(companion, index)"
                                    placeholder="Imię i nazwisko współlokatora"
                                    v-model="companion.value"
                                    :key="index"
                                    type="input"
                                    class="form-control"
                                />
                                <div
                                    class="text-danger"
                                    v-if="companion.status == 'already_filled'"
                                >
                                    Współlokator jest już przypisany do innego
                                    uczestnika
                                </div>
                                <div
                                    class="text-danger"
                                    v-if="companion.status == 'not_exist'"
                                >
                                    Taki współlokator nie istnieje.
                                </div>
                                <div
                                    class="text-danger"
                                    v-if="
                                        companion.status ==
                                        'registered_to_other_room'
                                    "
                                >
                                    Taki współlokator zapisał się do innego
                                    pokoju.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="registerType === 'hotels' && this.type === 'offline'"
                    class="col-md-4 col-sm-12 text-left"
                >
                    <label>Noclegi</label>
                    <div
                        class="form-check mb-1"
                        v-for="eventDate in eventDates"
                    >
                        <input
                            type="checkbox"
                            class="form-check-input"
                            :id="eventDate.date"
                            @change="setPrice"
                            :value="eventDate"
                            v-model="eventDate.checked"
                        />
                        <label class="form-check-label" :for="eventDate.date"
                            >{{ eventDate.date }}
                            <div
                                v-if="eventDate.is_required"
                                class="required-date"
                            >
                                (nocleg obowiązkowy)
                            </div></label
                        >
                    </div>
                </div>
            </div>

            <div v-if="customizableFormDisplay">
                <div
                    class="row mt-3 customizable-form-input-wrapper"
                    v-for="(form, index) in formFields.fields"
                >
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="row align-items-center text-sm-left pb-3">
                            <input
                                type="checkbox"
                                class="form-control col form-check-input-reverse col-1"
                                @change="setPrice"
                                @input="
                                    setFormField(
                                        form.name,
                                        'does_attend',
                                        $event.target.checked
                                    )
                                "
                                :disabled="
                                    isFieldTrue(form.name, 'with_companion')
                                "
                            />
                            <label class="col-10 mb-0">
                                <h5 class="mb-0" v-html="form.name"></h5>
                            </label>
                        </div>
                        <div
                            class="row align-items-center text-sm-left pb-3"
                            id="companion"
                            v-if="
                                isFieldTrue(form.name, 'does_attend') &&
                                isFieldTrue(form.name, 'companion_allowed')
                            "
                        >
                            <input
                                type="checkbox"
                                class="form-control col form-check-input-reverse col-1"
                                @change="setPrice"
                                @input="
                                    setFormField(
                                        form.name,
                                        'with_companion',
                                        $event.target.checked
                                    )
                                "
                            />
                            <label class="col-10 mb-0"
                                ><h5 class="mb-0">Osoba towarzysząca</h5></label
                            >
                        </div>
                        <div
                            class="form-row"
                            v-if="isFieldTrue(form.name, 'with_companion')"
                        >
                            <input
                                placeholder="Imię i nazwisko"
                                type="text"
                                size="col-md-6"
                                @input="
                                    setFormField(
                                        form.name,
                                        'companion_name',
                                        $event.target.value
                                    )
                                "
                            />
                        </div>
                        <hr
                            class="my-4"
                            style="background-color: white"
                            v-if="
                                index !=
                                Object.keys(formFields.fields).length - 1
                            "
                        />
                    </div>
                </div>

                <hr class="my-4" style="background-color: white" />
            </div>

            <div class="row">
                <div class="coupon-section col-md-4 col-sm-12">
                    <input
                        placeholder="Mam kod rabatowy"
                        v-model="code"
                        v-on:change="setPrice"
                    />
                    <h5>Cena: <span v-html="amount"></span>zł brutto</h5>
                    <h5>
                        Rabat: <span v-html="discountValue"></span>zł brutto
                    </h5>
                </div>

                <div class="payment-method-section col-md-4 col-sm-12">
                    <div class="form-check mb-1" v-if="this.amount > 0">
                        <input
                            type="radio"
                            class="form-check-input"
                            v-model="paymentMethod"
                            value="1"
                            id="przelewy24"
                        />
                        <label class="form-check-label" for="przelewy24"
                            ><img
                                class="przelewyLogo"
                                v-bind:src="
                                    getAssetPath('/images/przelewy24_logo.svg')
                                "
                        /></label>
                    </div>
                    <div class="form-check mb-0" v-if="this.amount > 0">
                        <input
                            type="radio"
                            class="form-check-input"
                            v-model="paymentMethod"
                            value="2"
                            id="przelew"
                        />
                        <label class="form-check-label" for="przelew"
                            >Przelew bankowy</label
                        >
                    </div>
                </div>
            </div>

            <hr class="mt-2 mb-5" style="background-color: white" />

            <div class="row">
                <div class="col-sm-12">
                    <div v-if="agreementInputs.length != 0">
                        <form-agreement-input
                            v-model="agreements"
                            :agreementInputs="agreementInputs"
                            :error-messages="errorMessages"
                        ></form-agreement-input>
                    </div>
                </div>

                <hr class="my-4 col-11" style="background-color: white" />

                <div class="offset-md-1 offset-sm-0 col-md-10 col-sm-12">
                    <div class="price-section">
                        <h3>
                            Cena finalna: <span v-html="amount"></span>zł brutto
                        </h3>
                        <h5>
                            Faktura zostanie wysłana automatycznie po otrzymaniu
                            płatności
                        </h5>
                        <h5 class="mb-4 mt-3">
                            Sprawdź aktualność
                            <a
                                class="data-info-link"
                                v-bind:href="profile_url"
                                target="_blank"
                            >
                                swoich danych
                            </a>
                            przed przejściem do płatności.
                        </h5>
                        <button
                            v-on:click="handlePaymentForm"
                            :disabled="isDisabled"
                        >
                            <span v-if="this.amount > 0"
                                >Przejdź do płatności</span
                            >
                            <span v-else>Potwierdź</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="bank-transfer" v-html="content"></div>
        <notifications group="foo" />
    </div>
</template>
<script>
import FormAgreementInput from "./formAgreementInput";

export default {
    props: [
        "event_id",
        "price",
        "asset_path",
        "profession",
        "profile_url",
        "register_type",
    ],

    components: {
        FormAgreementInput,
    },

    data() {
        return {
            paymentMethod: null,
            amount: this.price,
            profession: this.profession,
            code: null,
            discountValue: 0,
            content: null,
            customizableFormData: [],
            formFields: [],
            agreements: [],
            agreementInputs: [],
            errorMessages: [],
            numberOfRequireInputes: 0,
            isDisabled: false,
            type: "offline",
            customizableFormDisplay: true,
            hotelRooms: [],
            hotelRoom: null,
            eventDates: [],
            companions: [],
            registerType: this.register_type,
        };
    },
    beforeMount() {
        axios
            .get("/api/agreements", {
                params: {
                    eventableId: this.event_id,
                    eventableType: "App\\Models\\Event",
                },
            })
            .then((response) => {
                this.agreementInputs = response.data.data;
            });

        axios
            .get("/api/hotel-rooms", {
                params: {
                    eventableId: this.event_id,
                    eventableType: "App\\Models\\Event",
                },
            })
            .then((response) => {
                this.hotelRooms = response.data.data;
            });

        axios
            .get("/api/eventables/get-dates", {
                params: {
                    eventableId: this.event_id,
                    eventableType: "App\\Models\\Event",
                },
            })
            .then((response) => {
                this.eventDates = response.data;
            });

        axios
            .get("/api/customizable-forms", {
                params: {
                    eventableId: this.event_id,
                    eventableType: "App\\Models\\Event",
                },
            })
            .then((response) => {
                this.formFields = response.data.data;

                var newFormData = [];
                this.formFields.fields.forEach(function (item, index) {
                    newFormData[index] = {
                        form_name: item.name,
                        with_companion: false,
                        companion_allowed:
                            item.companion_allowed === "1" ? true : false,
                        does_attend: false,
                        companion_name: null,
                    };
                });

                this.customizableFormData = newFormData;
            });

        this.setPrice();
    },
    methods: {
        checkCompanion(companion, index) {
            if (companion.value == "") {
                this.$set(companion, "status", "ready_to_fill");
            } else {
                axios
                    .post("/api/check-companion", {
                        eventableId: this.event_id,
                        eventableType: "App\\Models\\Event",
                        hotelRoom: this.hotelRoom,
                        companion: companion.value,
                    })
                    .then((response) => {
                        console.log(response.data);
                        this.$set(companion, "status", response.data);
                        let msg = "";
                        if (response.data == "already_filled") {
                            msg =
                                "Wybrany uczestnik jest już zakwaterowany z inną osobą. Prosimy skontaktować się z organizatorem.";
                        } else if (response.data == "not_exist") {
                            msg = "Wybrany uczestnik nie istnieje";
                        } else if (
                            response.data == "registered_to_other_room"
                        ) {
                            msg =
                                "Wybrany uczestnik zapisał się do innego pokoju";
                        }

                        if (msg != "") {
                            this.$notify({
                                group: "foo",
                                type: "error",
                                title: msg,
                            });
                        }
                    })
                    .catch((error) => {
                        var errors = error.response.data.errors;
                        Object.values(errors).forEach((singleError) => {
                            this.$notify({
                                group: "foo",
                                type: "error",
                                title: singleError[0],
                            });
                        });
                    });
            }
        },
        setHotelRoom() {
            this.companions = [];
            for (let i = 0; i < this.hotelRoom.person_limit - 1; i++) {
                this.companions.push({ value: "", hasError: false });
            }
            this.setPrice();
        },
        geNumberOfRequireInputes() {
            for (let i = 0; i < this.agreementInputs.length; i++) {
                if (
                    this.agreementInputs[i].active == 1 &&
                    this.agreementInputs[i].required == 1
                ) {
                    this.numberOfRequireInputes++;
                }
            }
        },
        handlePaymentForm() {
            this.isDisabled = true;

            if (this.companions.length > 0) {
                const hasCompanionErrors = this.companions.some(
                    (companion) =>
                        companion.status === "already_filled" ||
                        companion.status === "not_exists"
                );

                if (hasCompanionErrors) {
                    this.$notify({
                        group: "foo",
                        type: "error",
                        title: "Wystąpiły błędy w danych współlokatorów",
                    });

                    this.isDisabled = false;
                    return false;
                }
            }

            if (this.paymentMethod === null && this.amount !== 0) {
                this.$notify({
                    group: "foo",
                    type: "error",
                    title: "Prosimy wybrać metodę płatności",
                });
                this.isDisabled = false;
                return false;
            }

            if (
                this.hotelRoom === null &&
                this.registerType === "hotels" &&
                this.type === "offline"
            ) {
                this.$notify({
                    group: "foo",
                    type: "error",
                    title: "Prosimy wybrać hotel",
                });

                this.isDisabled = false;
                return false;
            }
            if (this.type === "offline") {
                if (
                    this.eventDates.some(
                        (eventDate) =>
                            eventDate.is_required && !eventDate.checked
                    )
                ) {
                    this.$notify({
                        group: "foo",
                        type: "error",
                        title: "Proszę zaznaczyć wymagane daty",
                    });

                    this.isDisabled = false;
                    return false;
                }
            }

            if (this.agreementInputs.length != 0) {
                this.geNumberOfRequireInputes();
                if (
                    this.agreements.filter(Boolean).length <
                    this.numberOfRequireInputes
                ) {
                    this.$notify({
                        group: "foo",
                        type: "error",
                        title: "Prosimy zaznaczyć wszystkie wymagane zgody",
                    });
                    this.numberOfRequireInputes = 0;
                    this.isDisabled = false;
                    return false;
                }
                this.numberOfRequireInputes = 0;
            }

            if (this.type === "online") {
                this.customizableFormData = [];
            }

            axios
                .post("/api/payment/create", {
                    paymentMethod: this.paymentMethod,
                    eventableId: this.event_id,
                    eventableType: "App\\Models\\Event",
                    code: this.code,
                    amount: this.amount,
                    agreements: this.agreements,
                    customizableFormData: this.customizableFormData,
                    type: this.type,
                    hotelRoom: this.hotelRoom,
                    eventDates: this.eventDates,
                    companions: this.companions,
                })
                .then((response) => {
                    let data = response.data.data;
                    if (data.redirect_panel) {
                        this.$notify({
                            group: "foo",
                            type: "success",
                            title: response.data.message,
                        });

                        setTimeout(function () {
                            window.location.href = "/profil";
                        }, 1500);
                    }
                    if (data.url) {
                        this.$notify({
                            group: "foo",
                            type: "success",
                            title: response.data.message,
                        });

                        setTimeout(function () {
                            window.location.href = data.url;
                        }, 1500);
                    }
                    if (data.content) {
                        this.$notify({
                            group: "foo",
                            type: "success",
                            title: response.data.message,
                        });
                        this.content = data.content;
                        this.content +=
                            "</br></br> Kwota do zapłaty: " +
                            data.payment["amount"] +
                            "zł";
                    }
                })
                .catch((error) => {
                    this.isDisabled = false;
                    var errors = error.response.data.errors;
                    Object.values(errors).forEach((singleError) => {
                        this.$notify({
                            group: "foo",
                            type: "error",
                            title: singleError[0],
                        });
                    });
                });
        },
        setFormField(formName, inputName, value) {
            var existIndex = this.customizableFormData.findIndex((obj) => {
                return obj.form_name === formName;
            });

            if (existIndex === -1) {
                var newIndex = this.customizableFormData.length;
                var newArray = {
                    form_name: formName,
                };
                newArray[inputName] = value;
                this.$set(this.customizableFormData, newIndex, newArray);
            } else {
                var newArray = this.customizableFormData[existIndex];
                newArray[inputName] = value;
                this.$set(this.customizableFormData, existIndex, newArray);
            }
        },
        isFieldTrue(formName, inputName) {
            var existIndex = this.customizableFormData.findIndex((obj) => {
                return obj.form_name === formName;
            });

            if (existIndex === -1) {
                return false;
            }

            if (
                this.customizableFormData[existIndex][inputName] &&
                this.customizableFormData[existIndex][inputName] === true
            ) {
                return true;
            }
            return false;
        },
        setAgreement(e) {
            if (this.agreements.includes(e.target.value)) {
                var indexToDrop = this.agreements.indexOf(e.target.value);
                if (indexToDrop !== -1) {
                    this.agreements.splice(indexToDrop, 1);
                }
            } else {
                this.agreements.push(e.target.value);
            }
        },
        setPrice() {
            axios
                .post("/api/prices", {
                    customizableFormData: this.customizableFormData,
                    code: this.code,
                    eventableId: this.event_id,
                    eventableType: "App\\Models\\Event",
                    type: this.type,
                    eventDates: this.eventDates,
                    hotelRoom: this.hotelRoom,
                })
                .then((response) => {
                    this.amount = response.data.data.price;
                    this.discountValue = response.data.data.discountValue;
                })
                .catch((error) => {
                    this.amount = response.data.data.price;
                    this.discountValue = 0;
                    if (error.response.data.errors.code) {
                        this.$notify({
                            group: "foo",
                            type: "error",
                            title: error.response.data.errors.code[0],
                        });
                    }
                });
        },
        attendanceType(display) {
            this.setPrice();
            this.customizableFormDisplay = display;
        },
        getAssetPath(path) {
            return this.asset_path + path;
        },
    },
};
</script>
